exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__MarketLink__MarketLink {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n  .DS__MarketLink__MarketLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n  .DS__MarketLink__MarketLink:focus {\n    box-shadow: 0 0 2px 1px rgb(59, 153, 252);\n  }\n\n  .DS__MarketLink__MarketLink.DS__MarketLink__focus-visible {\n    outline: 2px auto #577edc;\n    outline-offset: 2px;\n  }\n", ""]);

// exports
exports.locals = {
	"MarketLink": "DS__MarketLink__MarketLink",
	"focus-visible": "DS__MarketLink__focus-visible"
};